import { Box } from "@mui/material";
import { CompanyType, ContactType } from "schemas/dashboard";

import styles from "./styles";

export const contactTypeIcons = {
  [ContactType.NotContactedThisWeek]: (
    <Box
      component="i"
      sx={[styles.icon, styles.star]}
      className="fa-solid fa-star"
    />
  ),
  [ContactType.NotContactedThisMonth]: (
    <Box
      component="i"
      sx={[styles.icon, styles.notContactedThisMonth]}
      className="fa-solid fa-calendar-minus"
    />
  ),
  [ContactType.NonGenericEmails]: (
    <Box
      component="i"
      className="fa-solid fa-user"
      sx={[styles.icon, styles.nonGeneric]}
    />
  ),
  [ContactType.HasContacts]: (
    <Box
      component="i"
      className="fa-solid fa-address-book"
      sx={[styles.icon, styles.hasContacts]}
    />
  ),
  [ContactType.NeverPitched]: (
    <Box
      component="i"
      className="fa-regular fa-circle-check"
      sx={[styles.icon, styles.neverEmailed]}
    />
  ),
};

export const companyTypeIcons = {
  [CompanyType.VerifiedPaidPartnership]: (
    <Box
      component="i"
      sx={[styles.icon, styles.paidPartnershipBadge]}
      className="fa-solid fa-briefcase"
    />
  ),
  [CompanyType.WorksWithUgc]: (
    <Box
      component="i"
      className="fa-solid fa-tag"
      sx={[styles.icon, styles.worksWithUgcBadge]}
    />
  ),
  [CompanyType.WorksWithInfluencer]: (
    <Box
      component="i"
      className="fa-solid fa-hashtag"
      sx={[styles.icon, styles.worksWithInfluencerBadge]}
    />
  ),
  [CompanyType.HasAds]: (
    <Box
      component="i"
      className="fa-solid fa-rectangle-ad"
      sx={[styles.icon, styles.ads]}
    />
  ),
  [CompanyType.EmergingBrand]: (
    <Box
      component="i"
      className="fa-solid fa-bolt"
      sx={[styles.icon, styles.emerging]}
    />
  ),
  [CompanyType.RunsTiktokAds]: (
    <Box
      component="i"
      className="fa-brands fa-tiktok"
      sx={[styles.icon, styles.tiktok]}
    />
  ),
  [CompanyType.WorksWithPodcasters]: <>🎙️</>,
  [CompanyType.WorksWithAgencies]: (
    <Box component="i" className="fa-solid fa-building" sx={[styles.icon]} />
  ),
  [CompanyType.WorksWithNewsletters]: (
    <Box
      component="i"
      className="fa-solid fa-envelope-open-text"
      sx={[styles.icon]}
    />
  ),
};
